import type { ReactNode } from 'react';

import { TabsItemButtonOrLink, TabsItemLi } from './TabsItem.styled';

type Props = {
  isSelected: boolean;
  children: ReactNode;
  onClick: () => void;
  href: string | null;
  variant: 'background' | 'marker' | 'compact-marker';
  tabButtonId: string;
  tabPanelId: string;
  qaId: string | undefined;
};

export function TabsItem({
  isSelected,
  children,
  onClick,
  href,
  variant,
  tabButtonId,
  tabPanelId,
  qaId,
}: Props) {
  return (
    <TabsItemLi data-qa-id="tabs-item">
      <TabsItemButtonOrLink
        data={
          href ? { type: 'link', href, onClick } : { type: 'button', onClick }
        }
        id={tabButtonId}
        qaId={qaId}
        data-variant={variant}
        aria-selected={isSelected}
        aria-controls={href ? undefined : tabPanelId}
      >
        {children}
      </TabsItemButtonOrLink>
    </TabsItemLi>
  );
}
